// #region imports

// --- Angular
import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';

// --- 3rd Party
import moment from 'moment';

// --- Hs Code
import {
  ResultsViews,
  ScoreModel,
  ResultsStatuses,
  SurveyResponseTypes,
} from '../../../models';

// #endregion

@Component({
  selector: 'hs-results-display',
  templateUrl: './results-display.component.html',
  styleUrls: ['./results-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsDisplayComponent implements OnChanges {
  @Input() title: string = '';
  @Input() resultsDisplayMode: ResultsViews | null = null;
  @Input() resultsStatus: ResultsStatuses = ResultsStatuses.surveyIncomplete;
  @Input() reportReleaseDate: Date | null = null;
  @Input() responseType: SurveyResponseTypes = SurveyResponseTypes.unknown;
  @Input() scores: ScoreModel[][] | null = null;
  @Input() othersResultsEmptyLabel: string = '';
  @Input() numberOfOthers: number = 0;
  @Input() isLocked: boolean = false;
  @Input() hideLockContent: boolean = false;
  @Input() imagesRootUrl: string = '';

  @Output() chartClicked = new EventEmitter();

  resultsViews = ResultsViews;
  resultsStatuses = ResultsStatuses;
  dateOfReportRelease: string = '';

  responseTypes = SurveyResponseTypes;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['reportReleaseDate'] && changes['reportReleaseDate'].currentValue) {
      this.dateOfReportRelease = moment(this.reportReleaseDate).format(
        'D MMMM YYYY'
      );
    }
  }

  isBeforeReportReleaseDate(): boolean {
    const now = new Date();
    const d = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth() + 1, // to cater for zero based list of months
        now.getDay(),
        now.getHours(),
        now.getMinutes()
      )
    );

    return moment(d).isBefore(moment(this.reportReleaseDate));
  }

  onChartClick() {
    this.chartClicked.emit();
  }
}
